<script>
import {generateUUID, percentage_format, numberWithCommas} from "@/utils.js";
import moment from "moment";
import baselinesData from "@/data/baselinesData.json";
import MarketingRecommendations from "@/view/components/campaign_analytics/MarketingRecommendations.vue";

export default {
  name: "control-vs-test-stores",
  props: [
    "form",  
    "isNetworkData",
    "disabledInAbsoluteValue",
    "campaignIsSearch",
    "active_tab",
    "campaignVsControlStoresMastercarddata", // all metric 
    "campaignVsControlStoresPosdata", // sales
    "marketing_recommendations",
    "timeDimention"
  ],
  components: {
    MarketingRecommendations
  },
  data() {
    return {
      options: {},
      series: [],
      result: [],
      temp_dates: [],
      dates: [],
      hasData: false,
      baselines: baselinesData,
      campaign_start: "",
      campaign_end: "",
      formkpi: {
        selectedKPIMetric : 'sales',
        selectedYearOver: 1,
      },
      overYearOption: [
        { text: "Year over Year", value: 1},
        { text: "Year over 2 Years", value: 2},
        { text: "Pre&Post Net of Control", value: 'ppnoc'},
      ],
      KPIMetricOptions : [
        { text: "Sales", value: 'sales'},
        { text: "Traffic", value: 'traffic'},
        { text: "Average Check", value: 'average_check'},
        { text: "Frequency", value: 'frequency'},
        { text: "Recency", value: 'recency'},
      ],
      isSearch: false,
      pos_metrics : [],
      region_metrics : [],
      total_sales_yoy_data : [],
      campaign_start_total_sales:[],
      campaign_end_total_sales:[],
      yoyCategoryView: "These values are reported in Year over Year changes",
      legendSelectors:Array.from({length: baselinesData.length+1}, (v, i) => true),
      graphColor:{
        color1:"#E91E63",
        color2: "#2E93fA",
        color3:"#FFFF00",
        color4:"#66DA26",
        color5:"#FF9800",
        color6:"#546E7A"
      },
      kpimetricDate:[],
      addCampaignStartDate:false,
      addCampaignEndDate:false
    };
  },
  mounted(){
    this.onSearch();
  },
  computed: {
    chartId() {
      return `chart_${generateUUID()}`;
    }
  }, 
  watch: {
    formkpi: {
      handler(data) {
        this.$emit('watchOverYear', data.selectedYearOver)
      },
      deep: true
    },
    isNetworkData() {
      this.onSearch();
    },
    "disabledInAbsoluteValue"(){
      if(this.disabledInAbsoluteValue){
        this.fetchData()
      }
    }
  },
  methods: {
    setPOSSalesSeries(apiData, dateCollection) {
      this.series = [];
      let data = [];
      for (let i = 0; i < dateCollection.length; i++) {
        let d = dateCollection[i];
        let total = 0;
        let filter_results = apiData.filter(
            obj => obj.date == d
        );
        for (let j = 0; j < filter_results.length; j++) {
          let item = filter_results[j];
          total = total + (item.avg_value ? parseFloat(item.avg_value) : 0);
        }
        total = (filter_results && filter_results.length ? total : 0);
        data.push({
          x: d,
          y: Math.round(total * 100) / 100
        });
      }
      return data

    },    
    displayPOSSales(){
        try {
            let apiresp  = this.campaignVsControlStoresPosdata.test_stores
            let apiresp2 = this.campaignVsControlStoresPosdata.control_stores
            let dates1 = this.campaignVsControlStoresPosdata.test_stores.map(item => item.date);    
            // Filter dates
            dates1 = dates1.filter((v, i, a) => a.indexOf(v) === i);
            let temp_camp_start =  moment(this.form.campaign.date_start).format('YYYY-MM-DD').toString()
            let temp_camp_end  =   moment(this.form.campaign.date_ended).format('YYYY-MM-DD').toString()

            if (!dates1.includes(temp_camp_start)) {
              dates1.push(temp_camp_start.toString());
              dates1 = dates1.sort();
              let start_index = dates1.indexOf(temp_camp_start.toString());
              let value = 0

              if (start_index+1 < dates1.length){
                let dateBefore = dates1[start_index - 1]
                let dateAfter = dates1[start_index + 1]
                let before_value = apiresp.find(obj => obj.date === dateBefore)? apiresp.find(obj => obj.date === dateBefore).avg_value : 0; // make it zero if avg_value is UNDEFINE
                
                let after_value = apiresp.find(obj => obj.date === dateAfter).avg_value;
                value = (Number(before_value) + Number(after_value)) / 2
              }
              apiresp.push({
              date : temp_camp_start.toString(),
              avg_value: value
              })             
            }
        
            if (!dates1.includes(temp_camp_end)) {
              dates1.push(temp_camp_end.toString());
              dates1 = dates1.sort();

              let end_index = dates1.indexOf(temp_camp_end.toString());
              let value = 0

              if (end_index+1 < dates1.length){
                let dateBefore = dates1[end_index - 1]
                let dateAfter = dates1[end_index + 1]
                let before_value = apiresp.find(obj => obj.date === dateBefore).avg_value;
                let after_value = apiresp.find(obj => obj.date === dateAfter).avg_value;
                value = (Number(before_value) + Number(after_value)) / 2
              }
              apiresp.push({
              date : temp_camp_end.toString(),
              avg_value: value
              })     
            }
            dates1 = dates1.sort();

            let dates2 = apiresp2.map(item => item.date);
            dates2 = dates2.filter((v, i, a) => a.indexOf(v) === i);    

            if (!dates2.includes(temp_camp_start)) {
              dates2.push(temp_camp_start.toString());
              dates2 = dates2.sort();
              let start_index = dates2.indexOf(temp_camp_start.toString());
              let value = 0

              if (start_index+1 < dates2.length){
                let dateBefore = dates2[start_index - 1]
                let dateAfter = dates2[start_index + 1]
                let before_value = apiresp2.find(obj => obj.date === dateBefore) != undefined ? apiresp2.find(obj => obj.date === dateBefore).avg_value : 0
                let after_value = apiresp2.find(obj => obj.date === dateAfter).avg_value;
                value = (Number(before_value) + Number(after_value)) / 2
              }
              apiresp2.push({
              date : temp_camp_start.toString(),
              avg_value: value
              })     
            }

            if (!dates2.includes(temp_camp_end)) {
              dates2.push(temp_camp_end.toString());
              dates2 = dates2.sort();

              let end_index = dates2.indexOf(temp_camp_end.toString());
              let value = 0

              if (end_index+1 < dates2.length){
                let dateBefore = dates2[end_index - 1]
                let dateAfter = dates2[end_index + 1]

                let before_value = apiresp2.find(obj => obj.date === dateBefore) != undefined ? apiresp2.find(obj => obj.date === dateBefore).avg_value : 0
                let after_value = apiresp2.find(obj => obj.date === dateAfter).avg_value;
                value = (Number(before_value) + Number(after_value)) / 2
              }
              apiresp2.push({
              date : temp_camp_end.toString(),
              avg_value: value
              })
            }
            dates2 = dates2.sort();    
            let maxDates = dates1;
            if (maxDates.length<dates2.length){
              maxDates = dates2;   
            }
            let testStores = this.setPOSSalesSeries(apiresp, maxDates)
            let controlStores = this.setPOSSalesSeries(apiresp2, maxDates)
            let  temp_series = []
            let legent1Name = 'Test Stores Total Sales'
            let legen2Name = 'Control Stores Total Sales'
            temp_series.push({
                name: legent1Name,        
                data: testStores
            });

            this.series = temp_series;
            this.setChartOptions();
            temp_series.push({
                name: legen2Name,        
                data: controlStores
            });
            this.series = temp_series;
            this.setChartOptions();
            setTimeout(() => {
                this.isSearch= false; 
            }, 1000);
        } catch (error) {
          console.log("Error in control str:",error)
        }
        
    },
    setSeriesByKPIMetric(apiData,dateCollection,current_selected_kpi_value){
        this.series = [];
        let data = [];
        for (let i = 0; i < dateCollection.length; i++) {
          let d = dateCollection[i];
          let total = 0;
          let filter_results = apiData.filter(
              obj => obj.date == d
          );
          for (let j = 0; j < filter_results.length; j++) {
            let item = filter_results[j];
            if (current_selected_kpi_value == this.KPIMetricOptions[0].value){
                total = total + (item.sales ? parseFloat(item.sales) : 0);                
            }
            else if(current_selected_kpi_value == this.KPIMetricOptions[1].value){
                total = total + (item.traffic ? parseFloat(item.traffic) : 0);
            }
            else if(current_selected_kpi_value == this.KPIMetricOptions[2].value){
                total = total + (item.average_check ? parseFloat(item.average_check) : 0);
            }
            else if(current_selected_kpi_value == this.KPIMetricOptions[3].value){
                total = total + (item.frequency ? parseFloat(item.frequency) : 0);
            }
            else if(current_selected_kpi_value == this.KPIMetricOptions[4].value){
                total = total + (item.recency ? parseFloat(item.recency) : 0);
            }
          }
          total = (filter_results && filter_results.length ? total : 0);
          data.push({
          x: d,
          y: Math.round(total * 100) / 100
          });
        }
        return data
    },
    displayMastercardData(){
      try {
        let apiresp  = this.campaignVsControlStoresMastercarddata.test_stores
        let apiresp2 = this.campaignVsControlStoresMastercarddata.control_stores
        let dates1 = this.campaignVsControlStoresMastercarddata.test_stores.map(item => item.date);   
         
        // Filter dates
        dates1 = dates1.filter((v, i, a) => a.indexOf(v) === i);
        let temp_camp_start =  moment(this.form.campaign.date_start).format('YYYY-MM-DD').toString()
        let temp_camp_end  =   moment(this.form.campaign.date_ended).format('YYYY-MM-DD').toString()
        let current_selected_kpi_value = this.formkpi.selectedKPIMetric;
        
        if (!dates1.includes(temp_camp_start)) {
          dates1.push(temp_camp_start.toString());
          dates1 = dates1.sort();
          let start_index = dates1.indexOf(temp_camp_start.toString());
          let value = 0          
          if (start_index+1 < dates1.length){
            let dateBefore = dates1[start_index - 1]
            let dateAfter = dates1[start_index + 1]
            if (current_selected_kpi_value == this.KPIMetricOptions[0].value){
              let before_value = apiresp.find(obj => obj.date === dateBefore).sales;
              let after_value = apiresp.find(obj => obj.date === dateAfter).sales;   
              value = (Number(before_value) + Number(after_value)) / 2  
              apiresp.push({
              date : temp_camp_start.toString(),
              sales: value
              })         
            }
            else if(current_selected_kpi_value == this.KPIMetricOptions[1].value){
              let before_value = apiresp.find(obj => obj.date === dateBefore).traffic;
              let after_value = apiresp.find(obj => obj.date === dateAfter).traffic;
              value = (Number(before_value) + Number(after_value)) / 2
              apiresp.push({
              date : temp_camp_start.toString(),
              traffic: value
              }) 
            }            
            else if(current_selected_kpi_value == this.KPIMetricOptions[2].value){
              let before_value = apiresp.find(obj => obj.date === dateBefore).average_check;
              let after_value = apiresp.find(obj => obj.date === dateAfter).average_check;
              value = (Number(before_value) + Number(after_value)) / 2              
              apiresp.push({
              date : temp_camp_start.toString(),
              average_check: value
              })
            }
            else if(current_selected_kpi_value == this.KPIMetricOptions[3].value){
              let before_value = apiresp.find(obj => obj.date === dateBefore).frequency;
              let after_value = apiresp.find(obj => obj.date === dateAfter).frequency;
              value = (Number(before_value) + Number(after_value)) / 2
              apiresp.push({
              date : temp_camp_start.toString(),
              frequency: value
              })
            }
            else if(current_selected_kpi_value == this.KPIMetricOptions[4].value){
              let before_value = apiresp.find(obj => obj.date === dateBefore).recency;
              let after_value = apiresp.find(obj => obj.date === dateAfter).recency;
              value = (Number(before_value) + Number(after_value)) / 2
              apiresp.push({
              date : temp_camp_start.toString(),
              recency: value
              })
            }
          }
        }
      
        if (!dates1.includes(temp_camp_end)) {
          dates1.push(temp_camp_end.toString());
          dates1 = dates1.sort();

          let end_index = dates1.indexOf(temp_camp_end.toString());
          let value = 0

          if (end_index+1 < dates1.length){
            let dateBefore = dates1[end_index - 1]
            let dateAfter = dates1[end_index + 1]
            if (current_selected_kpi_value == this.KPIMetricOptions[0].value){
              let before_value = apiresp.find(obj => obj.date === dateBefore).sales;
              let after_value = apiresp.find(obj => obj.date === dateAfter).sales;      
              value = (Number(before_value) + Number(after_value)) / 2
              apiresp.push({
              date : temp_camp_end.toString(),
              sales: value
              })     
            }
            else if(current_selected_kpi_value == this.KPIMetricOptions[1].value){
              let before_value = apiresp.find(obj => obj.date === dateBefore).traffic;
              let after_value = apiresp.find(obj => obj.date === dateAfter).traffic;
              value = (Number(before_value) + Number(after_value)) / 2
              apiresp.push({
              date : temp_camp_end.toString(),
              traffic: value
              })
            }
            else if(current_selected_kpi_value == this.KPIMetricOptions[2].value){
              let before_value = apiresp.find(obj => obj.date === dateBefore).average_check;
              let after_value = apiresp.find(obj => obj.date === dateAfter).average_check;
              value = (Number(before_value) + Number(after_value)) / 2
              apiresp.push({
              date : temp_camp_end.toString(),
              average_check: value
              })
            }
            else if(current_selected_kpi_value == this.KPIMetricOptions[3].value){
              let before_value = apiresp.find(obj => obj.date === dateBefore).frequency;
              let after_value = apiresp.find(obj => obj.date === dateAfter).frequency;
              value = (Number(before_value) + Number(after_value)) / 2
              apiresp.push({
              date : temp_camp_end.toString(),
              frequency: value
              })
            }
            else if(current_selected_kpi_value == this.KPIMetricOptions[4].value){
              let before_value = apiresp.find(obj => obj.date === dateBefore).recency;
              let after_value = apiresp.find(obj => obj.date === dateAfter).recency;
              value = (Number(before_value) + Number(after_value)) / 2
              apiresp.push({
              date : temp_camp_end.toString(),
              recency: value
              })
            }
          }          
        }
        dates1 = dates1.sort();

        let dates2 = apiresp2.map(item => item.date);
        dates2 = dates2.filter((v, i, a) => a.indexOf(v) === i);    

        if (!dates2.includes(temp_camp_start)) {
          dates2.push(temp_camp_start.toString());
          dates2 = dates2.sort();
          let start_index = dates2.indexOf(temp_camp_start.toString());
          let value = 0

          if (start_index+1 < dates2.length){
            let dateBefore = dates2[start_index - 1]
            let dateAfter = dates2[start_index + 1]
            if (current_selected_kpi_value == this.KPIMetricOptions[0].value){
              let before_value = apiresp2.find(obj => obj.date === dateBefore).sales;
              let after_value = apiresp2.find(obj => obj.date === dateAfter).sales; 
              value = (Number(before_value) + Number(after_value)) / 2 
              apiresp2.push({
              date : temp_camp_start.toString(),
              sales: value
              })                            
            }
            else if(current_selected_kpi_value == this.KPIMetricOptions[1].value){
              let before_value = apiresp2.find(obj => obj.date === dateBefore).traffic;
              let after_value = apiresp2.find(obj => obj.date === dateAfter).traffic;
              value = (Number(before_value) + Number(after_value)) / 2
              apiresp2.push({
              date : temp_camp_start.toString(),
              traffic: value
              })                
            }
            else if(current_selected_kpi_value == this.KPIMetricOptions[2].value){
              let before_value = apiresp2.find(obj => obj.date === dateBefore).average_check;
              let after_value = apiresp2.find(obj => obj.date === dateAfter).average_check;
              value = (Number(before_value) + Number(after_value)) / 2
              apiresp2.push({
              date : temp_camp_start.toString(),
              average_check: value
              })                
            }
            else if(current_selected_kpi_value == this.KPIMetricOptions[3].value){
              let before_value = apiresp2.find(obj => obj.date === dateBefore).frequency;
              let after_value = apiresp2.find(obj => obj.date === dateAfter).frequency;
              value = (Number(before_value) + Number(after_value)) / 2
              apiresp2.push({
              date : temp_camp_start.toString(),
              frequency: value
              })                
            }
            else if(current_selected_kpi_value == this.KPIMetricOptions[4].value){
              let before_value = apiresp2.find(obj => obj.date === dateBefore).recency;
              let after_value = apiresp2.find(obj => obj.date === dateAfter).recency;
              value = (Number(before_value) + Number(after_value)) / 2
              apiresp2.push({
              date : temp_camp_start.toString(),
              recency: value
              })                
            }            
          }          
        }

        if (!dates2.includes(temp_camp_end)) {
          dates2.push(temp_camp_end.toString());
          dates2 = dates2.sort();

          let end_index = dates2.indexOf(temp_camp_end.toString());
          let value = 0

          if (end_index+1 < dates2.length){
            let dateBefore = dates2[end_index - 1]
            let dateAfter = dates2[end_index + 1]
            if (current_selected_kpi_value == this.KPIMetricOptions[0].value){
              let before_value = apiresp2.find(obj => obj.date === dateBefore).sales;
              let after_value = apiresp2.find(obj => obj.date === dateAfter).sales;   
              value = (Number(before_value) + Number(after_value)) / 2
              apiresp2.push({
              date : temp_camp_end.toString(),
              sales: value
              })                           
            }
            else if(current_selected_kpi_value == this.KPIMetricOptions[1].value){
              let before_value = apiresp2.find(obj => obj.date === dateBefore).traffic;
              let after_value = apiresp2.find(obj => obj.date === dateAfter).traffic;
              value = (Number(before_value) + Number(after_value)) / 2
              apiresp2.push({
              date : temp_camp_end.toString(),
              traffic: value
              })                
            }
            else if(current_selected_kpi_value == this.KPIMetricOptions[2].value){
              let before_value = apiresp2.find(obj => obj.date === dateBefore).average_check;
              let after_value = apiresp2.find(obj => obj.date === dateAfter).average_check;
              value = (Number(before_value) + Number(after_value)) / 2
              apiresp2.push({
              date : temp_camp_end.toString(),
              average_check: value
              })                
            }
            else if(current_selected_kpi_value == this.KPIMetricOptions[3].value){
              let before_value = apiresp2.find(obj => obj.date === dateBefore).frequency;
              let after_value = apiresp2.find(obj => obj.date === dateAfter).frequency;
              value = (Number(before_value) + Number(after_value)) / 2
              apiresp2.push({
              date : temp_camp_end.toString(),
              frequency: value
              })                
            }
            else if(current_selected_kpi_value == this.KPIMetricOptions[4].value){
              let before_value = apiresp2.find(obj => obj.date === dateBefore).recency;
              let after_value = apiresp2.find(obj => obj.date === dateAfter).recency;
              value = (Number(before_value) + Number(after_value)) / 2
              apiresp2.push({
              date : temp_camp_end.toString(),
              recency: value
              })                
            }
          }
        }
        dates2 = dates2.sort();    
        let maxDates = dates1;
        if (maxDates.length<dates2.length){
          maxDates = dates2;   
        }
        let testStores = this.setSeriesByKPIMetric(apiresp, maxDates,current_selected_kpi_value)
        let controlStores = this.setSeriesByKPIMetric(apiresp2, maxDates,current_selected_kpi_value)
        let  temp_series = []
        let legent1Name = 'Test Stores '+current_selected_kpi_value
        let legen2Name = 'Control Stores '+current_selected_kpi_value
        temp_series.push({
          name: legent1Name,        
          data: testStores
        });

        this.series = temp_series;
        this.setChartOptions();

        temp_series.push({
          name: legen2Name,        
          data: controlStores
        });

        this.series = temp_series;
        this.setChartOptions();
        this.isSearch= false;         
      } catch (error) {
        console.log("Error:",error)
      }
    },
    async onSearch() {
      this.displayEmptyMessage = false;
      if (!this.form.selectedCampaign) {
        swal("Notice", "Campaign is required");
        return false
      }
       let campaign_start = moment(this.form.campaign.date_start).format(
          "MMM-DD-YYYY"
      );
      let campaign_end = moment(this.form.campaign.date_ended).format(
          "MMM-DD-YYYY"
      );
      
      this.campaign_start = campaign_start.toString();
      this.campaign_end = campaign_end.toString();

      this.isSearch = false
      // let start = moment(this.form.dtpicker.start)
      // let end = moment(this.form.dtpicker.end)
      // let daysCount = end.diff(start, 'days')  + 1 // plus 1 coz day 1 is zero value
      // let monthCount = end.diff(start, 'months') + 1 // plus 1 coz month 1 is zero value
      // let yearDataSelected = this.form.selectedYearOver
      // let campaignSelected = this.form.selectedCampaign.value
      
      

      
      if(this.isNetworkData == false){
        if((this.campaignVsControlStoresPosdata.length + this.campaignVsControlStoresMastercarddata.length) === 0){
            this.displayEmptyMessage = true
            this.series = [];
            this.setChartOptions();
            this.isSearch= false 
            return false
        }
      }
      else{
        if((this.campaignVsControlStoresMastercarddata.length) === 0){
            this.displayEmptyMessage = true
            this.series = [];
            this.setChartOptions();
            this.isSearch= false 
            return false
        }
      }

      if(this.isNetworkData == false){
        if (this.formkpi.selectedKPIMetric =='sales' ){
            this.displayPOSSales();
            console.log("Display POS data sales");

        }
        else{
            console.log("display selected metric of mastercard   ");
            this.displayMastercardData();
        }
      } 
      else{
        console.log("display selected metric of mastercard   ");
        this.displayMastercardData();
      }

    },    
    handleKPIMetricChanges(){
      this.onSearch();
    },
    
    setChartOptions() {
      let yearOver = this.formkpi.selectedYearOver
      let yaxisLabel= {
        show: false,
        formatter: function (val) {
          if (val === 0 || val === null) {
            return '0%';
          } else {
            return `${percentage_format(val)}`;
          }
        }
      }
      
      if (yearOver == 'ppnoc') { 
        yaxisLabel= {
          show: false,
          formatter: function (val) {
            return '$' + val.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,") 
          }
        }
      }
      this.options = {
        chart: {
          height: 350,
          type: "area",
          toolbar: {
            show: true,
            tools: {
              download:
                  '<i class="flaticon2-download-2" style="color:gray;" title="Download"></i>',
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset:
                  '<i class="flaticon2-refresh-button" style="color:gray;"></i>',
              customIcons: []
            }
          },          
          
        },
        colors: [
          "#E91E63",
          "#2E93fA",
          "#FFFF00",
          "#66DA26",
          "#FF9800",
          "#546E7A"
        ],
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "smooth"
        },
        title: {
          text: `Campaign Started ${this.campaign_start} to ${this.campaign_end}`,
          align: "left"
        },
        xaxis: {
          type: "datetime",
          labels: {
              formatter: function (value, timestamp) {
                // value = moment(value).add(6, 'days')
                return moment(value).format('MMM-DD-YYYY')
              } 
          },
        },
        yaxis: {
          show: true,
          showAlways: true,
          labels: yaxisLabel
        },
        tooltip: {
          x: {
            format: "dd/MM/yy",
            show: true
          },
          marker: {
            show: true
          }
        },
        annotations: {
          xaxis: [
            {
              x: this.campaign_start,
              x2: this.campaign_end,
              fillColor: "#333333",
              label: {
                style: {
                  color: "#fff",
                  background: "#333333"
                },
                orientation: "horizontal",
                text: "Campaign Range"
              }
            }
          ]
        }
      };
    }
    
    
  }
};
</script>

<template>
  <div class="control-store-div">
    <div class="dd-div">
      <div class="mr-2 dropdown-select">
        <v-select 
          v-model="formkpi.selectedYearOver"
          :items="overYearOption"
          required
          dense
          outlined
          background-color="#ffffff"
          height="42"
          :menu-props="{ top: false, offsetY: true }"
        ></v-select>
      </div>
      <div class="ml-3 dropdown-select">
        <v-select
          v-model="formkpi.selectedKPIMetric"
          :items="KPIMetricOptions"
          required
          dense
          outlined
          background-color="#ffffff"
          height="42"  
          width ="50"          
          :menu-props="{ top: false, offsetY: true }"
          
          @change="handleKPIMetricChanges"
          :disabled="this.disabledInAbsoluteValue"
        >            
        </v-select>          
      </div>
    </div>
    <p class="sb-p ma-2 "> 
      We have automatically selected locations as your control group based upon where you told us you ran your campaign. If you'd like to change your control group - either by adding or removing locations - you may do so by clicking the <span class="font-weight-black">Controls</span> button in the navigation bar.
    </p>
    <div>
      <marketing-recommendations  
        :class="disabledInAbsoluteValue ? 'absolute-val-css' : ''"
        active_tab="control-stores"
        :isNetworkData="isNetworkData"
        :campaignIsSearch="campaignIsSearch"
        :disabledInAbsoluteValue="disabledInAbsoluteValue"
        :form="form"  
        :marketing_recommendations="marketing_recommendations" 
        :timeDimention="timeDimention"
      ></marketing-recommendations>
    </div>
    <!-- <v-card elevation="3" class="mt-10"> -->
    <v-card elevation="3" class="v-card-ctrl" >
      <!-- <v-row class="justify-content-between" v-if="this.isSearch"> -->
      <v-row class="justify-space-between zindex-99" >
        <v-col class="mt-3 ml-3">
          <v-alert outlined type="info" text class="outer-container" width="500">
            <span v-if="this.formkpi.selectedYearOver === 1 || this.formkpi.selectedYearOver == 'ppnoc' || this.formkpi.selectedYearOver == 'hifi'">These values are reported in year over year changes</span>
          <span v-if="this.formkpi.selectedYearOver === 1">These values are reported in year over year changes</span>
          <span v-if="this.formkpi.selectedYearOver === 2">These values are reported in year over 2 year changes</span>
          <span v-if="this.formkpi.selectedYearOver === 3">No data for absolute values</span>
          </v-alert>
        </v-col>
      </v-row>
      <v-container fluid v-if="isSearch">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-container>
      <!-- v-if="!this.disabledInAbsoluteValue" -->
      <apexchart
          :options="options"
          :series="series"
          type="area"
          height="300"
          :id="chartId"          
      ></apexchart>
    </v-card>
  </div>
</template>
<style>
  .zindex-99{
    position: relative;
    z-index: 10;
  }
  .control-store-div .dropdown-select{
    max-width: 200px;
    display: inline-block;
  }
  .v-item--active .control-store-accord .dd-div{
    top: 10px;
    position: absolute;
    right: 70px;
  }
  .v-card-ctrl.v-sheet.v-card:not(.v-sheet--outlined){
    box-shadow: none !important;
  }
</style>
